import { __awaiter, __extends, __generator } from "tslib";
import { Data } from '@singularsystems/neo-core';
import ComponentBase from '../ComponentBase';
import LookupHelper from './LookupHelper';
var DropDownBase = /** @class */ (function (_super) {
    __extends(DropDownBase, _super);
    function DropDownBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.dataSource = null;
        _this.cachedDataSource = null;
        _this.fieldInfoContainer = null;
        _this.fieldDisplayInfo = null;
        return _this;
    }
    DropDownBase.prototype.findMembers = function (item) {
        var members = LookupHelper.findMembers(item, this.valueMember, this.displayMember);
        this.valueMember = members.valueMember;
        this.displayMember = members.displayMember;
    };
    DropDownBase.prototype.getItems = function (itemSource) {
        var _a;
        var items = [];
        if (itemSource instanceof Array) {
            items = itemSource;
        }
        else {
            if (itemSource instanceof Promise) {
                if (((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.promise) !== itemSource) {
                    this.dataSource = new Data.CallbackDataSource(function () { return itemSource; }, []);
                }
            }
            else if (itemSource.get !== undefined) {
                this.cachedDataSource = itemSource;
                if (this.cachedDataSource.willLoad) {
                    this.isLoading = true;
                }
                else {
                    this.dataSource = this.cachedDataSource.get();
                }
            }
            else if (itemSource.fetchInitial !== undefined) {
                this.dataSource = itemSource;
            }
            else {
                throw Error("Unknown drop down data source.");
            }
            if (this.dataSource) {
                this.isLoading = this.dataSource.willLoad;
                items = this.dataSource.data;
            }
        }
        return items;
    };
    DropDownBase.prototype.afterRender = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, bindProperty, displayValue, readableName, fieldInfo;
            return __generator(this, function (_b) {
                if (this.cachedDataSource) {
                    this.dataSource = this.cachedDataSource.get();
                }
                else if (this.dataSource) {
                    this.dataSource.fetchInitial();
                }
                if (this.fieldDisplayInfo) {
                    _a = this.fieldDisplayInfo, bindProperty = _a.bindProperty, displayValue = _a.displayValue, readableName = _a.readableName;
                    this.fieldDisplayInfo = null;
                    if (this.fieldInfoContainer) {
                        fieldInfo = this.fieldInfoContainer.setModelFieldInfo(bindProperty.propertyInfo, displayValue);
                        if (readableName) {
                            fieldInfo.displayName = readableName;
                        }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    DropDownBase.prototype.setFieldInfo = function (bindProperty, displayValue, readableName) {
        if (this.fieldInfoContainer) {
            this.fieldDisplayInfo = { bindProperty: bindProperty, displayValue: displayValue, readableName: readableName };
        }
    };
    return DropDownBase;
}(ComponentBase));
export { DropDownBase };
